import { actions } from "./actions";
import { commonStructure, readonlyStructure } from "./structure";
import { getMenuLabel, normalizeAction, sortOptionTemplate } from "./helpers";

const defaultMenu = webix.copy(commonStructure);
const readonlyMenu = webix.copy(readonlyStructure);

function getActionFromParent(parentId) {
	if (parentId == "format-row" || parentId == "format-column") parentId = "format";
	const actions = {
		"font-family": true,
		"font-size": true,
		"borders": true,
		"format": true,
		"text-align": true,
		"vertical-align": true,
	};
	return actions[parentId] ? parentId : null;
}

function getActionFromId(id){
	const actions = {
		"font-weight": true,
		"font-style": true,
		"underline": true,
		"strike": true,
		"wrap": true,
	};
	return actions[id] || false;
}

const ui = {
	getMenuData: function(menu, config, action, view){
		menu = menu.filter(o => o.menu !== false);
		
		for (let i = 0; i < menu.length; i++){
			if (typeof menu[i] == "string")
				menu[i] = { id: menu[i] };
			if ((menu[i].id == "resize-column" || menu[i].id == "resize-row") && !config.resizeCell) {
				menu.splice(i,1);
				i--;
				continue;
			}
			if (action) menu[i].action = action;
			if (!menu[i].value){
				if (!isNaN(parseInt(menu[i].id))) {
					menu[i].value = menu[i].id; // "font-size"
				} else {
					menu[i].value = getMenuLabel(menu[i].id, menu[i].action);
				}
			}

			if (menu[i].submenu) {
				const parentId = menu[i].id;
				const parentAction = getActionFromParent(parentId);
				menu[i].submenu = {
					data: this.getMenuData(menu[i].submenu, config, parentAction, view),
					config: {
						template: obj => {
							if (obj.id === "sort-sheet-asc" || obj.id === "sort-sheet-desc") {
								return sortOptionTemplate(obj, view);
							}
							return obj.value;
						},
						on: {
							onBeforeShow(){
								this.refresh(); // for the updated template result with current selected cell to actually render
							}
						}
					}
				};
			}
		}

		return menu.sort((a, b) => a.menuOrder - b.menuOrder);
	}
};

export function init(view){
	view.attachEvent("onComponentInit", () => ready(view));

	const config = view.config;
	const menu = {
		view: "menu",
		borderless: true,
		css: "webix_ssheet_menu",
		id: "menu",
		autowidth: true,
		type:{
			height: 40
		},
		data: ui.getMenuData(
			webix.isArray(config.menu) ? config.menu : webix.copy(config.readonly ? readonlyMenu : defaultMenu),
			config,
			"",
			view
		),
	};

	view.callEvent("onViewInit", ["menu", menu]);
	return menu;
}


function ready(view){
	const menu = view.$$("menu");
	if (menu) {
		menu.attachEvent("onMenuItemClick", (id) => callAction(view,id));

		if (menu.getItem("edit")) {
			const editSub = menu.getSubMenu("edit");
			if (editSub) {
				editSub.attachEvent("onBeforeShow", function() {
					const area = view._table.getSelectArea();
					if (!area || area.start.row === area.end.row) {
						editSub.filter(o => o.id !== "sort-range");
					} else {
						editSub.filter();
					}
				});
			}
		}
	}
}
function callAction(view,id){
	if (view.callEvent("onMenuItemClick", [id])) {
		if (actions[id]) {
			actions[id](view);
		} else {
			const topMenu = view.$$("menu");
			const option = topMenu.getMenuItem(id);
			let action = option.action;
			
			if (!action && getActionFromId(id)) {
				action = id;
				id = undefined;
			}

			if (action == "format" && id == "common")
				id = "";

			if (action && !(action == "format" && id == "custom")) {
				view.callEvent("onStyleSet", [action, id]);
				return;
			}
			
			if (!option.submenu) {
				const actionParams = { id, value: option.value, group: option.group };
				normalizeAction(actionParams);
				view.callEvent("onCommand", [actionParams]);
			}
		}
	}
}
